<template>
  <div id="welcome-section">
    <h2 id="target">Design</h2>
    <TemplateChooser no-edit />
    <ProductTemplatePreview compact="true" />

    <div class="upload-cta-area" v-if="productTemplateDesignId">
      <StartOrderButton/>
    </div>

    <div class="upload-cta-area" v-else>
      <b-button
        to="/dashboard/design/new"
        variant="default"
      >Upload Your Design</b-button>
    </div>
    <router-link to="/dashboard/design" class="minor cta-link">View</router-link>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {designUploadSuccess, designUploadError} from '@/lib/track/events';
export default {
  computed: {
    ...mapGetters(['productTemplateDesignId', 'heroState', 'flags']),
    showTooltip() {
      return this.heroState === 'step3';
    }
  },
  methods: {
    onUpload() {
      designUploadSuccess();
    },
    onError(error) {
      designUploadError(error);
    },
  }
}
</script>

<style lang="scss" scoped>
.upload-cta-area {
  padding-top: 1em;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/home/DesignSection.vue